export default function({ route, redirect, query, app }) {
  const maintenanceMode = process.env.maintenanceMode === 'true'
  const bypassToken = process.env.maintenanceBypassToken

  // Permite acesso se token de bypass for fornecido
  if (query.bypass && bypassToken && query.bypass === bypassToken) {
    // Armazena o bypass no sessionStorage para persistir durante a navegação
    if (process.client) {
      sessionStorage.setItem('maintenance_bypass', 'true')
    }
    return
  }

  // Verifica se já tem bypass no sessionStorage
  if (process.client && sessionStorage.getItem('maintenance_bypass') === 'true') {
    return
  }

  // Sempre permite acesso à própria página de manutenção
  if (route.path.includes('/maintenance')) {
    return
  }

  // Se modo de manutenção não estiver ativo, permite acesso
  if (!maintenanceMode) {
    return
  }

  // Bloqueia todas as rotas quando em modo manutenção
  return redirect(app.localePath({ name: 'maintenance' }))
}
